import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectProductTypes } from 'services/productTypes/selectors';

const makeSelectOptions = (): any =>
    createDeepEqualSelector(
        selectProductTypes,
        productTypesState =>
            productTypesState &&
            productTypesState.map((item: any) => {
                const { id, name } = item;

                return {
                    key: id,
                    text: name,
                    value: id
                };
            })
    );

export { makeSelectOptions };
